import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import configJson from '../config.json';

var envConfig = (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'test') ? process.env.NODE_ENV:'development';

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token'

// Http endpoint DEV
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || configJson[envConfig].url_hasura;

const httpLink = new HttpLink({
  uri: httpEndpoint,
})

const handleGrapqlError = async function (error) {
  var { extensions } = error
  var bus = new Vue();
  var errTitle = 'Lỗi kết nối';
  var errMessage = 'Vui lòng tải lại trang và thử lại';
  console.log('extensions', extensions);
  if (extensions?.code == 'invalid-jwt') {
    setTimeout(function () {
      window.location.reload()
    }, 3000)
    return;
  }
  if (extensions?.code == 'constraint-violation') {
    errTitle = 'Lỗi dữ liệu'
    errMessage = 'Lỗi ràng buộc giữa các dữ liệu, không thể thực hiện thao tác này'
  }
  bus.$toast.add({ severity: 'error', summary: errTitle, detail: errMessage, life: 5000 })
}

const errorHandler = onError(({ networkError, graphQLErrors }) => {
  var bus = new Vue();

  if (graphQLErrors)
    graphQLErrors.map(handleGrapqlError)

  if (networkError) {
    bus.$toast.add({ severity: 'error', summary: 'Lỗi kết nối', detail: 'Vui lòng kiểm tra kết nối internet', life: 5000 })
    console.error(`[Network error]: ${networkError}`)
  }
})

// Config
const defaultOptions = {
  httpEndpoint,
  wsEndpoint: null,
  tokenName: AUTH_TOKEN,
  persisting: false,
  websocketsOnly: false,
  ssr: false,
  link: errorHandler.concat(httpLink),
}

let stApolloClient

// Call this in the Vue app file
export function createProvider(options = {}) {
  const { apolloClient, wsClient } = createApolloClient({
    ...defaultOptions,
    ...options,
  })
  apolloClient.wsClient = wsClient

  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler(error) {
      console.error('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    },
  })

  stApolloClient = apolloClient

  return apolloProvider
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
  if (!apolloClient) apolloClient = stApolloClient
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    console.error('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (!apolloClient) apolloClient = stApolloClient
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    console.error('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
}
